"use client";

// Homepage "No personal guarantees" glass-bar visual (GuaranteesMock) driven by
// the same scroll-triggered motion as AnimatedGuaranteesCard, but without the
// card chrome/lede so it can sit beside the bento row copy.

import { useRef } from "react";

import {
  GUARANTEES_DURATION_MS,
  GuaranteesMock,
} from "@/components/home/terms-grid-static";
import type { TermsCopy } from "@/components/home/terms-grid-static";
import { useGuaranteesPlaybackPhase } from "@/components/home/terms-grid-static/use-guarantees-playback-phase";
import { useTermsCardMotion } from "@/components/home/terms-grid-static/use-terms-card-motion";
import { cn } from "@/lib/utils";

export function AnimatedGuaranteesVisual({
  copy,
  className,
}: {
  copy: TermsCopy;
  className?: string;
}) {
  const ref = useRef<HTMLDivElement>(null);
  const { state, phase, reducedMotion } = useTermsCardMotion(
    ref,
    GUARANTEES_DURATION_MS
  );
  const effectivePhase = useGuaranteesPlaybackPhase(
    state,
    phase,
    reducedMotion,
    GUARANTEES_DURATION_MS
  );
  const mockPhase =
    phase ?? (state === "complete" ? undefined : effectivePhase);

  return (
    <div
      ref={ref}
      data-testid="restaurant-guarantees-visual"
      className={cn("relative overflow-hidden", className)}
    >
      {/* GuaranteesMock positions itself against a 280px homepage card; shift
          up so the glass bar sits vertically centred in the bento row. */}
      <div className="absolute inset-x-0 top-[-70px] h-[280px] lg:top-[-40px]">
        <GuaranteesMock copy={copy} motionState={state} phase={mockPhase} />
      </div>
    </div>
  );
}
